/* Beauty Bar — Cheerful celebration flowing from top, 5 seconds */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var canvas = document.getElementById('bb-fireworks');
  if (!canvas) return;

  var ctx = canvas.getContext('2d', { alpha: true });
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0;

  function resize() {
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width  = W * dpr;
    canvas.height = H * dpr;
    canvas.style.width  = W + 'px';
    canvas.style.height = H + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize, { passive: true });

  // Bright cheerful palette
  var COLORS = [
    '#FF4D6D','#FF85A1','#FFD166','#FFEE32','#06D6A0',
    '#9B5DE5','#00BBF9','#FF6B9D','#F15BB5','#FEE440','#C9A96E'
  ];

  var isMobile = W < 750;
  var DURATION = 5000;
  var startTime = performance.now();
  var lastSpawn = 0;

  var pieces = [];

  function rand(a,b){ return a + Math.random()*(b-a); }
  function pick(a){ return a[(Math.random()*a.length)|0]; }

  // shapes: 0 = ribbon, 1 = circle dot, 2 = star
  function Piece() {
    this.x  = Math.random() * W;
    this.y  = -20 - Math.random() * 60;
    this.vx = rand(-1.2, 1.2);
    this.vy = rand(2.2, 4.2);
    this.size = rand(6, 11);
    this.color = pick(COLORS);
    this.rot = Math.random() * 6.283;
    this.rotSpd = rand(-0.18, 0.18);
    this.wobbleAmp = rand(0.6, 1.6);
    this.wobbleFreq = rand(0.015, 0.035);
    this.shape = Math.random() < 0.15 ? 2 : (Math.random() < 0.5 ? 0 : 1);
    this.alive = true;
  }
  Piece.prototype.step = function () {
    this.y += this.vy;
    this.x += this.vx + Math.sin(this.y * this.wobbleFreq) * this.wobbleAmp;
    this.rot += this.rotSpd;
    if (this.y > H + 30) this.alive = false;
  };
  Piece.prototype.draw = function () {
    ctx.save();
    ctx.translate(this.x, this.y);
    ctx.rotate(this.rot);
    ctx.fillStyle = this.color;
    ctx.globalAlpha = 0.95;
    if (this.shape === 0) {
      // ribbon
      ctx.fillRect(-this.size / 2, -this.size / 3.5, this.size, this.size / 1.8);
    } else if (this.shape === 1) {
      // dot
      ctx.beginPath();
      ctx.arc(0, 0, this.size / 2.2, 0, 6.283);
      ctx.fill();
    } else {
      // star
      drawStar(0, 0, 5, this.size / 1.8, this.size / 4);
    }
    ctx.restore();
  };

  function drawStar(cx, cy, spikes, outer, inner) {
    var rot = Math.PI / 2 * 3;
    var x = cx, y = cy;
    var step = Math.PI / spikes;
    ctx.beginPath();
    ctx.moveTo(cx, cy - outer);
    for (var i = 0; i < spikes; i++) {
      x = cx + Math.cos(rot) * outer; y = cy + Math.sin(rot) * outer;
      ctx.lineTo(x, y); rot += step;
      x = cx + Math.cos(rot) * inner; y = cy + Math.sin(rot) * inner;
      ctx.lineTo(x, y); rot += step;
    }
    ctx.closePath();
    ctx.fill();
  }

  function frame(now) {
    ctx.clearRect(0, 0, W, H);

    var elapsed = now - startTime;

    // cheerful steady flow — light enough to read the page
    if (elapsed < DURATION) {
      var gap = isMobile ? 110 : 70;
      if (now - lastSpawn > gap) {
        var batch = isMobile ? 2 : 3;
        for (var i = 0; i < batch; i++) pieces.push(new Piece());
        lastSpawn = now;
      }
    }

    for (var i = pieces.length - 1; i >= 0; i--) {
      pieces[i].step();
      pieces[i].draw();
      if (!pieces[i].alive) pieces.splice(i, 1);
    }

    if (elapsed < DURATION || pieces.length) {
      requestAnimationFrame(frame);
    } else {
      canvas.style.display = 'none';
    }
  }

  requestAnimationFrame(frame);
})();